package com.findyourbuddies.website.utils

object ResourcesUtils {

    fun getResourcePath(path: String): String {
        return if (EnvironmentUtils.getEnvironment() == Environment.DEV) path
        else "/resources$path"
    }
}
